/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
export type MenuLocale = {
  noResultsMsg: string;
  parentMenuItemAriaLabel: string;
  noResultsStatus: string;
  itemsAvailableStatus: (count: number) => string;
};
const locale: MenuLocale = {
  noResultsMsg: 'No results',
  noResultsStatus: 'No options available',
  itemsAvailableStatus: (count: number) => `${count} ${count === 1 ? 'option' : 'options'} available`,
  parentMenuItemAriaLabel: `Opens submenu. Press Enter or right arrow to open.`
};
export default locale;